const spacingNum = (theme) => {
  /**
   * provide an alternative to the spacing function that returns a string with px
   *
   * @param {number} value - The spacing value
   * 
   * @returns {number} a number reprersenting pixels without the 'px'
   */
  const spacingNum = (value) => Number(theme.spacing(value).slice(0, -2));

  return {
    ...theme,
    spacingNum,
  }
}

export default spacingNum;